import React from 'react'
import cn from 'classnames'
import { Field } from 'redux-form'
import RadioButton from '../../../../forms/RadioButton'
import Button from '../../../../forms/Button'
import PadlockIcon from './PadlockIcon'
import CloseIcon from '../../../../billing/CurrentDue/MergePurchasesModal/CloseIcon';
import CircleLoader from '../../../../common/CircleLoader'

import styles from './styles.module.css'

const ChooseSmsType = ({ handleChangeScreen, selectedType, closeModal, loading }) => {
  return (
    <div className={styles.content}>
      <div className={styles.box}>
        <CloseIcon className={styles.close} onClick={closeModal} />
        <header className={styles.header}>
          <PadlockIcon className={styles.icon} />
          <h2 className={cn('h2', styles.title)}>Welcome to Wing!</h2>
          <h3 className={cn('h3', styles.subTitle)}>Please sign in.</h3>
        </header>
        <main>
          <p className={cn('p_basic', styles.text)}>
            We’ll send a verification code to the phone number or email linked
            to your account. Select below.
          </p>
          <div className={styles.formWrapper}>
            <div className={styles.form}>
              <Field
                component={RadioButton}
                label="Text me the code"
                name="code_sending_mode"
                radioValue="sms"
              />
              <Field
                component={RadioButton}
                label="Email me the code"
                name="code_sending_mode"
                radioValue="email"
              />
              <Button
                type="button"
                className={styles.sendCodeBtn}
                disabled={!selectedType}
                onClick={handleChangeScreen}
              >
                Send code
              </Button>
            </div>
          </div>
          {loading && (
            <div className={styles.loaderWrapper}>
              <CircleLoader showLoader={loading} />
            </div> 
          )}
        </main>
      </div>
    </div>
  )
}

export default ChooseSmsType